import { ByWeekday, RRule, RRuleSet, WeekdayStr } from 'rrule';
export type RecurrenceRuleSet = RRuleSet;
export type RecurrenceRule = RRule;
export type RecurrenceWeekdayStr = WeekdayStr;

export enum Frequency {
  YEARLY = 0,
  MONTHLY = 1,
  WEEKLY = 2,
  DAILY = 3,
  HOURLY = 4,
}

export interface Options {
  freq: Frequency;
  dtstart: Date | null;
  until: Date | null;
  interval: number;
  count: number | null;
  bymonthday: number | number[] | null;
  byweekday: number | string | null;
  byhour: number | number[] | null;
  byminute: number | number[] | null;
  bysecond: number | number[] | null;
}

export const rruleDateTime = function (
  y: number,
  m: number,
  d: number,
  h = 0,
  i = 0,
  s = 0,
) {
  return new Date(Date.UTC(y, m - 1, d, h, i, s));
};
export function getRecurrenceRuleSet(): RecurrenceRuleSet {
  return new RRuleSet();
}

export function getRecurrenceRule(options: Options): RecurrenceRule {
  const { byweekday, ...otherOptions } = options;
  let byweekdayValue;
  if (typeof options.byweekday === 'number') {
    byweekdayValue = wdayToConstant(options.byweekday);
  } else if (typeof options.byweekday === 'string') {
    byweekdayValue = wdayStrToConstant(options.byweekday);
  }

  return new RRule({
    ...otherOptions,
    byweekday: byweekdayValue,
    wkst: RRule.SU,
    // tzid: 'Asia/Tokyo',
  });
}

function wdayToConstant(wday: number | null) {
  switch (wday) {
    case 0:
      return RRule.SU;
    case 1:
      return RRule.MO;
    case 2:
      return RRule.TU;
    case 3:
      return RRule.WE;
    case 4:
      return RRule.TH;
    case 5:
      return RRule.FR;
    case 6:
      return RRule.SA;
    default:
      return null;
  }
}

function wdayStrToConstant(wday: string) {
  switch (wday) {
    case 'SU':
      return RRule.SU;
    case 'MO':
      return RRule.MO;
    case 'TU':
      return RRule.TU;
    case 'WE':
      return RRule.WE;
    case 'TH':
      return RRule.TH;
    case 'FR':
      return RRule.FR;
    case 'SA':
      return RRule.SA;
    default:
      return null;
  }
}

export function frequencyToConstant(freq: string): Frequency | null {
  switch (freq) {
    case 'YEARLY': {
      return Frequency.YEARLY;
    }
    case 'MONTHLY': {
      return Frequency.MONTHLY;
    }
    case 'WEEKLY': {
      return Frequency.WEEKLY;
    }
    case 'DAILY': {
      return Frequency.DAILY;
    }
    case 'HOURLY': {
      return Frequency.HOURLY;
    }
    default: {
      return null;
    }
  }
}
